import Vue from 'vue'
import VueAutosize from 'vue-autosize'

Vue.use(VueAutosize)



// WEBPACK FOOTER //
// ./src/plugins/autosize.js